angular.module('tgaAdmin').controller('CouponController', [
  '$scope',
  '$state',
  '$filter',
  'userService',
  'flashService',
  'modalService',
  'productService',
  'gameService',
  '$translate',
  function ($scope, $state, $filter, userService, flashService, modalService, productService, gameService, $translate) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      coupon_id: $state.params.id || null,
      date_start_formatted: null,
      date_end_formatted: null,
      subscription_expiration_formatted: null,
      statuses: [
        {
          id: 1,
          name: 'Enabled',
        },
        {
          id: 0,
          name: 'Disabled',
        },
      ],
      types: [
        {
          id: 'percentage',
          name: 'Percentage',
        },
        {
          id: 'fixed',
          name: 'Fixed Amount',
        },
        {
          id: 'trial',
          name: 'Trial',
        },
        {
          id: 'paid',
          name: 'Paid',
        },
        {
          id: 'partner',
          name: 'Partner',
        },
      ],
      trial_units: [
        {
          id: 'day',
          name: 'Day(s)',
        },
        {
          id: 'week',
          name: 'Week(s)',
        },
        {
          id: 'month',
          name: 'Month(s)',
        },
        {
          id: 'year',
          name: 'Year(s)',
        },
      ],
      affiliates: [],
      salespersons: [],
      game_types: [],
    };

    $scope.viewmodel = {
      name: null,
      description: null,
      code: null,
      type: null,
      affiliate_id: null,
      salesperson_id: null,
      discount: null,
      max_amount: null,
      paid_amount: null,
      trial_duration: null,
      trial_unit: null,
      num_admins: null,
      num_editors: null,
      num_players: null,
      open_bundle: null,
      bundle_price: null,
      game_types: null,
      uses_total: null,
      uses_per_user: null,
      date_start: null,
      date_end: null,
      subscription_expiration: null,
      expired: false,
      status: null,
    };

    $scope.initialize = function () {
      productService.getAffiliates().then((affiliates) => {
        $scope.data.affiliates = affiliates;
      });
      productService.getSalespersons().then((salespersons) => {
        $scope.data.salespersons = salespersons;
      });
      if ($scope.data.coupon_id) {
        productService.getCoupon($scope.data.coupon_id).then((coupon) => {
          $scope.viewmodel = coupon;

          if (coupon.date_start) {
            $scope.data.date_start_formatted = $filter('date')(
              $filter('parseDate')(coupon.date_start),
              'shortDate',
              'UTC',
            );
          }

          if (coupon.date_end) {
            $scope.data.date_end_formatted = $filter('date')($filter('parseDate')(coupon.date_end), 'shortDate', 'UTC');
          }

          if (coupon.subscription_expiration) {
            $scope.data.subscription_expiration_formatted = $filter('date')(
              $filter('parseDate')(coupon.subscription_expiration),
              'shortDate',
              'UTC',
            );
          }

          $scope.title = `<span class="text-muted">${$translate
            .instant('coupon.edit_activation_code')
            .toString()} /</span> ${$scope.viewmodel.name}`;
        });
      }

      // Get game types, filtering out those not available in the cart.
      $scope.data.game_types = gameService.getGameTypes().filter(
        (type) => ['5s', 'flash', 'wbs'].indexOf(type.key) === -1, // true if not one of these
      );
    };

    $scope.actions = {
      deleteCoupon(form) {
        modalService
          .showModal(
            {
              title: $translate.instant('common.delete_confirm_title').toString(),
              message: $translate.instant('common.delete_confirm_body').toString(),
              closeButton: $translate.instant('common.no').toString(),
              actionButton: $translate.instant('common.yes').toString(),
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              form.processing = true;
              productService.deleteCoupon($scope.viewmodel).then(
                () => {
                  flashService.set(
                    `<span class="fa fa-check"></span> ${$translate
                      .instant('coupon.activation_code_deleted')
                      .toString()}`,
                    'success',
                  );
                  $state.go('v1.coupon');
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  form.processing = false;
                },
              );
            },
            () => {},
          );
      },
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;
        const t = $translate;

        if ($scope.viewmodel.type === 'paid') {
          $scope.viewmodel.bundle_price = $scope.viewmodel.paid_amount;
        }
        if ($scope.data.coupon_id) {
          productService.updateCoupon($scope.viewmodel).then(
            () => {
              flashService.set(
                `<span class="fa fa-check"></span> ${t.instant('coupon.activation_code_updated').toString()}`,
                'success',
              );
              $state.go('v1.coupon');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              form.processing = false;
            },
          );
        } else {
          productService.addCoupon($scope.viewmodel).then(
            () => {
              flashService.set(
                `<span class="fa fa-check"></span> ${t.instant('coupon.activation_code_created').toString()}`,
                'success',
              );
              $state.go('v1.coupon');
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              form.processing = false;
            },
          );
        }
      },
      generate() {
        /* var array = new Uint32Array(1);
          window.crypto.getRandomValues(array); */
        const code = Math.random()
          .toString(36)
          .substring(2, 11);
        $scope.viewmodel.code = code;
      },
      changeType() {
        if (
          $scope.viewmodel.type === 'trial'
          || $scope.viewmodel.type === 'paid'
          || $scope.viewmodel.type === 'partner'
        ) {
          $scope.viewmodel.discount = null;
          $scope.viewmodel.max_amount = null;
        } else {
          $scope.viewmodel.trial_duration = null;
          $scope.viewmodel.trial_unit = null;
        }

        if ($scope.viewmodel.type !== 'paid') {
          $scope.viewmodel.paid_amount = null;
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      changeGameTypes() {
        if ($scope.viewmodel.game_types.length > 0) {
          $scope.viewmodel.open_bundle = true;
          // console.log('selected game_types:', $scope.viewmodel.game_types);
        } else {
          $scope.viewmodel.open_bundle = null;
          // console.log('no game_types selected.');
        }
      },
    };

    $scope.initialize();
  },
]);
